import * as i0 from '@angular/core';
import { EventEmitter, Output, Inject, Component, NgModule } from '@angular/core';
import * as i5 from '@angular/material/paginator';
import { MatPaginatorModule } from '@angular/material/paginator';
import * as i6 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i7 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i8 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i9 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i2 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i1 from '@azavista/components/shared';
import { AzavistaSharedModule } from '@azavista/components/shared';
import * as i10 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import * as i11 from '@azavista/components/selected-items-count';
import { AzavistaSelectedItemsCountModule } from '@azavista/components/selected-items-count';
import { Subject } from 'rxjs';
import * as i3 from '@angular/common';
import * as i4 from '@ngx-translate/core';
function AzavistaSearchItemsComponent_ng_container_13_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "mat-checkbox", 20);
    i0.ɵɵlistener("change", function AzavistaSearchItemsComponent_ng_container_13_li_1_Template_mat_checkbox_change_1_listener($event) {
      const item_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.itemCheckboxChanged(item_r2, $event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r2.isSelected(item_r2));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r2[ctx_r2.itemDisplayTextPropertyName], " ");
  }
}
function AzavistaSearchItemsComponent_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaSearchItemsComponent_ng_container_13_li_1_Template, 3, 2, "li", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.data.items);
  }
}
function AzavistaSearchItemsComponent_ng_container_14_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "mat-checkbox", 20);
    i0.ɵɵlistener("change", function AzavistaSearchItemsComponent_ng_container_14_li_1_Template_mat_checkbox_change_1_listener($event) {
      const item_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.itemCheckboxChanged(item_r5, $event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r2.isSelected(item_r5));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r5[ctx_r2.itemDisplayTextPropertyName], " ");
  }
}
function AzavistaSearchItemsComponent_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaSearchItemsComponent_ng_container_14_li_1_Template, 3, 2, "li", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.currentPageItems);
  }
}
function AzavistaSearchItemsComponent_li_23_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "mat-checkbox", 20);
    i0.ɵɵlistener("change", function AzavistaSearchItemsComponent_li_23_Template_mat_checkbox_change_1_listener($event) {
      const item_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectedItemCheckboxChanged(item_r7, $event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r7[ctx_r2.itemDisplayTextPropertyName], " ");
  }
}
let AzavistaSearchItemsComponent = /*#__PURE__*/(() => {
  class AzavistaSearchItemsComponent {
    constructor(sharedSvc, dialogRef, data) {
      this.sharedSvc = sharedSvc;
      this.dialogRef = dialogRef;
      this.data = data;
      this.searchChanged = new EventEmitter();
      this.itemDisplayTextPropertyName = 'label';
      this.selectedItems = [];
      this.calculatedPagingOptions = {
        pageSizes: [],
        length: 0,
        pageIndex: 0,
        pageSize: 0
      };
      this.pagingData = {
        limit: 0,
        object_count: 0,
        offset: 0,
        pageSizes: []
      };
      this.searchText = '';
      this.pushChanges = new Subject();
      this.currentPageItems = [];
    }
    ngOnInit() {
      this.itemDisplayTextPropertyName = this.data.displayProperty || 'label';
      this.pushChangesSubscription = this.pushChanges.subscribe(x => {
        this.changesPushed(x);
      });
      this.pagingData = this.data.pagingOptions;
      this.calculatedPagingOptions = this.sharedSvc.createCalculatedPagingOptions(this.data.pagingOptions);
      this.selectedItems = [...(this.data.selectedItems || [])];
      if (this.data.performPagingLocally) {
        this.currentPageItems = this.getCurrentPageItems();
      }
    }
    getCurrentPageItems() {
      let items;
      if (this.searchText) {
        items = this.data.items.filter(x => this.containsText(x[this.itemDisplayTextPropertyName], this.searchText));
      } else {
        items = this.data.items;
      }
      if (this.data.performPagingLocally) {
        // All items must be provided when performing paging locally is requested
        const start = this.calculatedPagingOptions.pageIndex * this.calculatedPagingOptions.pageSize;
        const end = start + this.calculatedPagingOptions.pageSize;
        return items.slice(start, end);
      } else {
        return items;
      }
    }
    containsText(value, textToSearch) {
      if (!value) {
        return false;
      }
      return value.toLowerCase().indexOf(textToSearch.toLowerCase()) >= 0;
    }
    ngOnDestroy() {
      this.pushChangesSubscription.unsubscribe();
    }
    changesPushed(data) {
      this.data = data;
      this.calculatedPagingOptions = this.sharedSvc.createCalculatedPagingOptions(this.data.pagingOptions);
    }
    isSelected(item) {
      const existingIndex = this.getSelectedItemIndex(item.id);
      return existingIndex >= 0;
    }
    itemCheckboxChanged(item, change) {
      if (this.data.singleSelection) {
        this.selectedItems = [];
        if (change.checked) {
          this.selectedItems.push(item);
        }
        return;
      }
      const existingIndex = this.getSelectedItemIndex(item.id);
      if (existingIndex >= 0 && !change.checked) {
        // An existing item is unchecked - remove it
        this.selectedItems.splice(existingIndex, 1);
        return;
      } else if (existingIndex === -1 && change.checked) {
        // Non existing item is checked - add it
        this.selectedItems.push(item);
      }
    }
    selectedItemCheckboxChanged(item, change) {
      const existingIndex = this.getSelectedItemIndex(item.id);
      if (existingIndex >= 0) {
        this.selectedItems.splice(existingIndex, 1);
      }
    }
    onPaging(pageEvent) {
      this.pagingData = {
        limit: pageEvent.pageSize,
        offset: pageEvent.pageIndex * pageEvent.pageSize,
        object_count: 0,
        pageSizes: []
      };
      this.notifySearchChanged(false, true);
      if (this.data.performPagingLocally) {
        this.calculatedPagingOptions = this.sharedSvc.createCalculatedPagingOptions({
          limit: this.pagingData.limit,
          offset: this.pagingData.offset,
          object_count: this.data.items.length,
          pageSizes: this.pagingData.pageSizes
        });
        this.currentPageItems = this.getCurrentPageItems();
      }
    }
    onSearchTextChanged(value) {
      this.searchText = value;
      this.pagingData.offset = 0;
      this.calculatedPagingOptions.pageIndex = 0;
      this.notifySearchChanged(true, false);
      if (this.data.performPagingLocally) {
        this.currentPageItems = this.getCurrentPageItems();
        return;
      }
    }
    notifySearchChanged(searchTextChanged, pagingChanged) {
      const data = {
        paging: this.pagingData,
        searchText: this.searchText,
        searchTextChanged: searchTextChanged,
        pagingChanged: pagingChanged
      };
      this.searchChanged.next(data);
    }
    onCancelClick() {
      this.dialogRef.close();
    }
    onSelectClick() {
      this.dialogRef.close(this.selectedItems);
    }
    getSelectedItemIndex(id) {
      return this.selectedItems.findIndex(x => x.id === id);
    }
    static {
      this.ɵfac = function AzavistaSearchItemsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaSearchItemsComponent)(i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(i2.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaSearchItemsComponent,
        selectors: [["azavista-search-items"]],
        outputs: {
          searchChanged: "searchChanged"
        },
        standalone: false,
        decls: 35,
        vars: 24,
        consts: [[1, "search-items-container", "azavista-search-items-component"], ["mat-dialog-title", "", 1, "search-items-header", "aza-cmp-dialog-title"], [3, "data"], ["mat-dialog-content", "", 1, "aza-cmp-dialog-content"], [1, "search-items-search-box-container"], [1, "aza-cmp-full-width"], ["matPrefix", ""], ["matInput", "", 3, "input", "placeholder"], [1, "search-items-list-container"], [1, "search-items-list", "aza-cmp-no-padding"], [4, "ngIf"], ["showFirstLastButtons", "", 3, "page", "pageSizeOptions", "length", "pageIndex", "pageSize"], [1, "selected-items-title"], ["translate", ""], [1, "search-items-selected-items-list-container"], [1, "search-items-selected-items-list"], [4, "ngFor", "ngForOf"], ["mat-dialog-actions", "", 1, "aza-cmp-dialog-actions"], ["color", "primary", 1, "aza-cmp-dialog-action-cancel-button", 3, "click"], ["color", "primary", 1, "aza-cmp-dialog-action-apply-button", 3, "click", "disabled"], ["color", "primary", 3, "change", "checked"]],
        template: function AzavistaSearchItemsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h1", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "azavista-selected-items-count", 2);
            i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "mat-form-field", 5)(7, "mat-icon", 6);
            i0.ɵɵtext(8, " search ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "input", 7);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵlistener("input", function AzavistaSearchItemsComponent_Template_input_input_9_listener($event) {
              return ctx.onSearchTextChanged($event.target.value);
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(11, "div", 8)(12, "ul", 9);
            i0.ɵɵtemplate(13, AzavistaSearchItemsComponent_ng_container_13_Template, 2, 1, "ng-container", 10)(14, AzavistaSearchItemsComponent_ng_container_14_Template, 2, 1, "ng-container", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "mat-paginator", 11);
            i0.ɵɵlistener("page", function AzavistaSearchItemsComponent_Template_mat_paginator_page_15_listener($event) {
              return ctx.onPaging($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "h2", 12)(17, "span", 13);
            i0.ɵɵtext(18, "SELECTED_ITEMS");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "span");
            i0.ɵɵtext(20);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(21, "div", 14)(22, "ul", 15);
            i0.ɵɵtemplate(23, AzavistaSearchItemsComponent_li_23_Template, 3, 2, "li", 16);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(24, "div", 17)(25, "azavista-flat-button", 18);
            i0.ɵɵlistener("click", function AzavistaSearchItemsComponent_Template_azavista_flat_button_click_25_listener() {
              return ctx.onCancelClick();
            });
            i0.ɵɵelementStart(26, "span");
            i0.ɵɵtext(27);
            i0.ɵɵpipe(28, "translate");
            i0.ɵɵpipe(29, "uppercase");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(30, "azavista-button", 19);
            i0.ɵɵlistener("click", function AzavistaSearchItemsComponent_Template_azavista_button_click_30_listener() {
              return ctx.onSelectClick();
            });
            i0.ɵɵelementStart(31, "span");
            i0.ɵɵtext(32);
            i0.ɵɵpipe(33, "translate");
            i0.ɵɵpipe(34, "uppercase");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.data.title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("data", ctx.data == null ? null : ctx.data.selectedItemsCountData);
            i0.ɵɵadvance(6);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 14, "SEARCH"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", !ctx.data.performPagingLocally);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data.performPagingLocally);
            i0.ɵɵadvance();
            i0.ɵɵproperty("pageSizeOptions", ctx.calculatedPagingOptions.pageSizes)("length", ctx.calculatedPagingOptions.length)("pageIndex", ctx.calculatedPagingOptions.pageIndex)("pageSize", ctx.calculatedPagingOptions.pageSize);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1("(", ctx.selectedItems.length, ")");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.selectedItems);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(29, 18, i0.ɵɵpipeBind1(28, 16, "CANCEL")));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", (ctx.data.validateSelectedItemsFn == null ? null : ctx.data.validateSelectedItemsFn(ctx.selectedItems)) === false);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(34, 22, i0.ɵɵpipeBind1(33, 20, "SELECT")));
          }
        },
        dependencies: [i3.NgForOf, i3.NgIf, i4.TranslateDirective, i5.MatPaginator, i6.MatCheckbox, i7.MatFormField, i7.MatPrefix, i8.MatIcon, i9.MatInput, i10.AzavistaButtonComponent, i10.AzavistaFlatButtonComponent, i11.AzavistaSelectedItemsCountComponent, i2.MatDialogTitle, i2.MatDialogActions, i2.MatDialogContent, i3.UpperCasePipe, i4.TranslatePipe],
        styles: [".search-items-container[_ngcontent-%COMP%]{max-height:80vh}.search-items-list[_ngcontent-%COMP%], .search-items-selected-items-list[_ngcontent-%COMP%]{list-style-type:none}.search-items-list-container[_ngcontent-%COMP%]{max-height:30vh;overflow:auto}.search-items-selected-items-list-container[_ngcontent-%COMP%]{max-height:8em;overflow:auto}"]
      });
    }
  }
  return AzavistaSearchItemsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaSearchItemsModule = /*#__PURE__*/(() => {
  class AzavistaSearchItemsModule {
    static {
      this.ɵfac = function AzavistaSearchItemsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaSearchItemsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaSearchItemsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AzavistaSharedModule, MatPaginatorModule, MatCheckboxModule, MatFormFieldModule, MatIconModule, MatInputModule, AzavistaButtonModule, AzavistaSelectedItemsCountModule, MatDialogModule]
      });
    }
  }
  return AzavistaSearchItemsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaSearchItemsComponent, AzavistaSearchItemsModule };
